<template>
  <div class="mb-5" id="topico-link-container">
    <div class="aviso-aba-aberta jumbotron" v-if="tipoLinkExterno">
      <div class="d-flex flex-column flex-xl-row align-items-center justify-content-center w-100">
        <p class="lead text-center text-xl-left pb-4">
          Outra <strong>aba foi aberta</strong> em seu navegador com o arquivo.<br>Caso isso não tenha ocorrido,<br><a target="_blank" :href="url">clique aqui</a>.
        </p>
        <img class="img-fluid" :src="imagemAbaAberta" alt="outra aba aberta">
      </div>
    </div>
    <iframe :src="url" width="100%" height="1000vh" v-else></iframe>
  </div>
</template>

<script>
import TipoLink, { TipoLinkUtil } from '@/core/types/tipo-link'

export default {
  name: 'TopicoLink',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tipoLinkExterno: false,
      url: ''
    }
  },
  methods: {
    obterTopico: function () {
      this.url = this.ementaCurso.topico_escolhido.url
      this.tipoLinkExterno = this.tipoConteudoLink === TipoLink.EXTERNO
      if (this.tipoLinkExterno) {
        window.open(this.ementaCurso.topico_escolhido.url, 'conteudo-link')
      }
    }
  },
  computed: {
    tipoConteudoLink: function () {
      return TipoLinkUtil.obterPorCodigoInterno(this.ementaCurso.topico_escolhido.codigo_interno)
    },
    imagemAbaAberta () {
      return require('@/assets/img/nova-aba-aberta.png')
    }
  },
  mounted () {
    this.obterTopico()
  },
  watch: {
    ementaCurso: function () {
      this.obterTopico()
    }
  }
}
</script>
